import { render, staticRenderFns } from "./DeliveryIncomeByProductType.vue?vue&type=template&id=7030f4cd&lang=pug&"
import script from "./DeliveryIncomeByProductType.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIncomeByProductType.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryIncomeByProductType.vue?vue&type=style&index=0&id=7030f4cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports